/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bronze_Lush_Pike_StirInputs */

const en_bronze_lush_pike_stir = /** @type {(inputs: Bronze_Lush_Pike_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes`)
};

const de_bronze_lush_pike_stir = /** @type {(inputs: Bronze_Lush_Pike_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmale`)
};

/**
* | output |
* | --- |
* | "Attributes" |
*
* @param {Bronze_Lush_Pike_StirInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bronze_lush_pike_stir = /** @type {((inputs?: Bronze_Lush_Pike_StirInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bronze_Lush_Pike_StirInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bronze_lush_pike_stir(inputs)
	return de_bronze_lush_pike_stir(inputs)
});